function initListFilter() {
    const filters = document.querySelectorAll('.filter');

    filters.forEach(filter => {
        filter.addEventListener('click', function () {
            const current = document.querySelector('.filter.active');
            if (current) {
                current.classList.remove('active');
            }
            this.classList.add('active');

            const selectedFilter = filter.getAttribute('data-filter');
            let itemsToHide = document.querySelectorAll(`.filter-parent .filter-child:not([data-filter='${selectedFilter}'])`);
            let itemsToShow = document.querySelectorAll(`.filter-parent [data-filter='${selectedFilter}']`);

            if (selectedFilter === 'all') {
                itemsToHide = [];
                itemsToShow = document.querySelectorAll('.filter-parent [data-filter]');
            }

            itemsToHide.forEach(el => {
                el.classList.add('hide');
                el.classList.remove('show');
            });

            itemsToShow.forEach(el => {
                el.classList.remove('hide');
                el.classList.add('show');
            });
        });
    });

    // Search filter functionality
    const input = document.getElementById('searchInput');
    const searchResults = document.getElementById('searchResults');

    if (input && searchResults) {
        input.addEventListener('input', () => {
            const filter = input.value.toLowerCase();
            searchResults.innerHTML = '';

            const fileBlocks = document.querySelectorAll('.filter-child .file-block');

            fileBlocks.forEach(block => {
                const title = block.querySelector('.file-block__title')?.textContent.toLowerCase() || '';
                const desc = block.querySelector('.file-block__description')?.textContent.toLowerCase() || '';

                if (filter.length > 1 && (title.includes(filter) || desc.includes(filter))) {
                    const clone = block.cloneNode(true);
                    clone.classList.remove('hide');
                    clone.classList.add('cell', 'small-6', 'large-4');
                    searchResults.appendChild(clone);
                }
            });
        });
    }
}

export default initListFilter;
